var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-card-grid-item"},[(_vm.catalogElement.element.entity ==='Combo')?_c('Combo',{attrs:{"catalogElement":_vm.catalogElement}}):_c('ProductCardSmall',{attrs:{"catalogElement":_vm.catalogElement}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }